// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b2178f3b","598":"06d5382e"}[chunkId] + ".chunk.js";
};